/**
 * Live feedback, computed from the pegs alone — the solution never reaches the client
 * (CLAUDE.md §10). It says one thing only: more than one peg is left and none can jump. That
 * is a fact about the board the player is looking at, provable without the key, and it is
 * sound: no later move exists, so the position is lost. A position that merely *looks*
 * hopeless (isolated pegs that could still be reached) stays silent.
 */
import type { Feedback } from "../types";
import { isStuck, parseBoard, replay } from "./board";
import type { PegSolitaireDefinition, PegSolitaireProgress } from "./types";

export function localFeedback(
  definition: PegSolitaireDefinition,
  progress: PegSolitaireProgress,
): Feedback[] {
  const { board, pegs } = parseBoard(definition.board);
  const outcome = replay(board, pegs, progress.moves ?? []);
  if (!isStuck(board, outcome.pegs)) return [];
  return [
    { type: "deadlock", code: "no_move_left", cells: [], params: { left: outcome.pegs.size } },
  ];
}
